import React from 'react';
import Base from '../base';
import SendAnnouncementForm from '../../components/forms/announcements/sendAnnouncementForm';

/**
 * Envío de anuncios (versión 1): el wrapper `Base` aporta el menú lateral
 * clásico. La entrada en ese menú la pinta el módulo `Enviar Anuncios`.
 */
export default function SendAnnouncement() {
  return (
    <Base>
      <SendAnnouncementForm />
    </Base>
  );
}
